import { Type } from "class-transformer";
import { GenDocField } from "./gen-doc-field.model";
import { DatabaseUserGroup } from "src/modules/database/shared/database-user-group.model";
import { GenDocAttachment } from "./gen-doc-attachment.model";

export class GenDoc {
    id = 0;
    type = "";
    typeVersion = 0;
    version = 0;
    @Type(() => GenDocField)
    fields: GenDocField[] = [];
    @Type(() => GenDocAttachment)
    attachments: GenDocAttachment[] = [];
    createdBy = "";
    @Type(() => Date)
    creationDate: Date
    modifiedBy = "";
    @Type(() => Date)
    modifyDate: Date
    status = "";
    @Type(() => DatabaseUserGroup)
    visibleForGroups: DatabaseUserGroup[];
    templateName = "";

    getField(id: string): GenDocField {
        return this.fields.find(f => f.fieldId == id);
    }
}